// Angular
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'kt-confirm-select-entity-dialog',
	standalone: true,
	imports: [
		CommonModule,
		MatDialogModule,
		MatFormFieldModule,
		MatSelectModule,
		MatOptionModule,
		MatButtonModule,
		TranslateModule
	],
	templateUrl: './confirm-select-entity-dialog.component.html',
  styleUrls: ['../modal.scss']
})
export class ConfirmSelectEntityDialogComponent implements OnInit {
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
 	public errorMessage: string = '';
 	public loading: boolean = false;
  public isSubmitted: boolean = true;
	constructor(
		public dialogRef: MatDialogRef<ConfirmSelectEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
			// console.log('data', data);
	 }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
			for(let item of this.data.dataList){
				if(item._id === this.data.data){
					this.dialogRef.close(item);
					break;
				}
			}
	}
	public onChange(data) {
		// console.log(data);
      this.data.data = data.value;
  }
}
